import React from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { isInKioskMode } from "utils"
import { Button } from "components"
import classes from "./index.module.scss"

const printerInterfacesLabels = {
  tcp: "Ethernet",
  bluetooth: "Bluetooth",
  usb: "USB"
}

const Printers = () => {
  const [t, i18n] = useTranslation()

  const history = useHistory()

  const printers = useSelector(state => state.printers)

  const handleNavigate = (printer, pIndex) => {
    history.push(
      kioskMode ? "/kiosk-printer" : "/printer",
      {
        printerId: printer._id,
        initialPrinterIndex: pIndex
      }
    )
  }

  const handleAddPrinter = () => {
    history.push(
      kioskMode ? "/kiosk-printer" : "/printer",
      { numberOfPrinters: printers.length }
    )
  }

  const kioskMode = isInKioskMode()

  const printerTypesOptions = {
    thermal: t("حرارتی"),
    label: t("لیبل"),
    laser: t("لیزری")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"]
      )}
    >
      <div className={classes["table-container"]}>
        <table className={classes["table"]}>
          <thead className={classes["header"]}>
            <tr>
              <th className={classes["header-item"]}>
                {t("اسم")}
              </th>
              <th className={classes["header-item"]}>
                {t("مدل_پرینتر")}
              </th>
              <th className={classes["header-item"]}>
                {t("نوع_ارتباط")}
              </th>
              <th className={classes["header-item"]}>
                {t("Ip_آدرس")}
              </th>
              <th
                className={clsx(
                  classes["header-item"],
                  classes["center"]
                )}
              >
                {t("جزئیات")}
              </th>
            </tr>
          </thead>

          <tbody>
            {printers.map((printer, pIndex) =>
              <tr key={printer._id} className={classes["printer"]}>
                <td className={classes["text"]}>
                  {printer.printerName}
                </td>
                <td className={classes["text"]}>
                  {printerTypesOptions[printer.printerModel]}
                </td>
                <td className={classes["text"]}>
                  {printer.printerModel === "thermal"
                    ? printerInterfacesLabels[printer.printerInterface]
                    : t("درایور")
                  }
                </td>
                <td className={classes["text"]}>
                  {printer.printerInterface === "tcp"
                    ?
                    printer.ipAddress
                    :
                    printer.printerInterface === "bluetooth"
                      ? printer.macAddress
                      : printer.deviceId
                  }
                </td>
                <td
                  className={clsx(
                    classes["text"],
                    classes["center"]
                  )}
                >
                  <Button
                    onClick={() => handleNavigate(printer, pIndex)}
                  >
                    {t("مشاهده")}
                  </Button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className={classes["footer"]}>
        <Button
          color="success"
          onClick={handleAddPrinter}
        >
          {t("اضافه_کردن_پرینتر")}
        </Button>
      </div>
    </div>
  )
}

export default Printers